<template>
  <div class="col-sm-12 col-md-12 card-head">
    <h5 class="d-inline">
      {{ id }} &nbsp; {{ criteria.description }}
    </h5>
    <table class="table table-bordered">
      <thead class="card-print">
        <tr>
          <th rowspan="2">
            Id
          </th>
          <th rowspan="2">
            Obligation
          </th>
          <th rowspan="2">
            Description
          </th>
          <th colspan="3">
            Observation
          </th>
        </tr>
        <tr>
          <th>Compliance</th>
          <th>Notes</th>
          <th>Created At</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="indicator in indicators">
          <tr class="m-t-10 card-print">
            <td :rowspan="indicator.observations.length == 0 ?1:indicator.observations.length" class="text-left">
              {{ indicator.control_point_name }}
            </td>
            <td :rowspan="indicator.observations.length == 0 ?1:indicator.observations.length" class="text-left">
              <span v-if="indicator.obligation === 'MAJOR_MUST'">Major Must</span>
              <span v-if="indicator.obligation === 'MINOR_MUST'">Minor Must</span>
            </td>
            <td :rowspan="indicator.observations.length == 0 ?1:indicator.observations.length">
              {{ indicator["description"] }}
            </td>
            <td>
              <template v-if="indicator.observations.length > 0">
                <span v-if="indicator.observations[0].compliance === 'Compliant'" class="text-dark-green">Compliant</span>
                <span v-if="indicator.observations[0].compliance === 'NonCompliant'" class="text-danger">Non-Compliant</span>
                <span v-if="indicator.observations[0].compliance === 'NotApplicable'" class="text-secondary">Not Applicable</span>
              </template>
            </td>
            <td>
              <template v-if="indicator.observations.length > 0">
                <span v-html="indicator.observations[0].procedural_note" />
              </template>
            </td>
            <td>
              <template v-if="indicator.observations.length > 0">
                <span v-html="indicator.observations[0].created_at" />
              </template>
            </td>
          </tr>
          <template v-for="(observation, i) in indicator.observations">
            <tr v-if="i > 0">
              <td>
                <span v-if="observation.compliance === 'Compliant'" class="text-dark-green">Compliant</span>
                <span v-if="observation.compliance === 'NonCompliant'" class="label label-danger">Non-Compliant</span>
                <span v-if="observation.compliance === 'NotApplicable'" class="label label-secondary">Not Applicable</span>
              </td>
              <td>
                <span v-html="observation.procedural_note" />
              </td>
              <td>{{ observation.created_at }}</td>
            </tr>
          </template>
<!--          <indicator :id="indicator.control_point_id" :key="indicator.control_point_id" :status="status" :audit-id="auditId" :auditor="auditor" :name="indicator.control_point_name" :indicator="indicator" />-->
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import Indicator from './Indicator.vue';
export default {
  name: 'Criteria',
  components: { Indicator },
  props: ['auditId', 'criteria', 'id', 'impactArea', 'events', 'status', 'auditor', 'certificationId', 'principleId'],
  data() {
    return {
      indicators: []
    };
  },
  mounted() {
    this.getIndicators();
  },
  methods: {
    async getIndicators() {
      this.indicators = [];
      try {
        const { data } = await this.$api.get(`audits/certifications/${this.certificationId}/impact_areas/${this.impactArea}/principles/${this.principleId}/criteria/${this.criteria.criterion}/control_points`);
        for (let i = 0; i < data.length; i++) {
          // eslint-disable-next-line no-unused-vars
          let observations = (await this.$api.get(`audits/${this.auditId}/control_points/${data[i].control_point_id}/observations`)).data;
          data[i]['observations'] = observations;
        }
        this.indicators = data;
      } catch (e) {
        console.error(e);
      }
    },
    getPityName(name) {
      return name.substring(name.indexOf(' '));
    }
  }
}
</script>

<style scoped>
</style>
